/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  from,
  InMemoryCache,
  Operation,
  split,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { useAuthContext } from '@authentication/Authentication';
import { createClient } from 'graphql-ws';
import { PropsWithChildren, useMemo } from 'react';
import { KeyFieldPolicies } from './keyFieldPolicies';
import { QueryPolicies } from './queryPolicies';

export const Apollo = ({ children }: PropsWithChildren) => {
  const { token, authenticated } = useAuthContext();

  const errorLink = onError(({ graphQLErrors, operation, forward }) => {
    if (graphQLErrors) {
      return forward(operation);
    }
    return null;
  });

  const httpLinkUri =
    process.env.GATSBY_IS_LOCAL === 'true'
      ? process.env.GATSBY_GRAPHQL_DEV_URL
      : process.env.GATSBY_GRAPHQL_URL;
  const httpLink = createHttpLink({
    uri: httpLinkUri,
  });

  const authLink = useMemo(
    () =>
      setContext((_, { headers }: { headers: Record<string, unknown> }) => {
        if (!authenticated || !token) {
          return { headers };
        }
        try {
          return {
            headers: {
              ...headers,
              Authorization: `Bearer ${token}`,
            },
          };
        } catch (error) {
          return { headers };
        }
      }),
    [token, authenticated],
  );

  // Only create the WebSocket link in the browser
  const link = useMemo(() => {
    let baseLink = from([authLink, errorLink, httpLink]);
    if (typeof window !== 'undefined') {
      const wsImpl = typeof WebSocket !== 'undefined' ? WebSocket : null;

      const wsUrl = process.env.GATSBY_CORE_WEBSOCKET_URL;
      const wsLink = new GraphQLWsLink(
        createClient({
          url: `${wsUrl}/graphql`,
          webSocketImpl: wsImpl,
        }),
      );

      const splitLink = split(
        ({ query }: Operation) => {
          const definition = getMainDefinition(query);
          return (
            definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
          );
        },
        wsLink,
        httpLink,
      );

      baseLink = from([authLink, errorLink, splitLink]);
    }
    return baseLink;
  }, [authLink]);

  const client = useMemo(
    () =>
      new ApolloClient({
        link,
        defaultOptions: {
          query: {
            fetchPolicy: 'cache-first',
          },
        },
        cache: new InMemoryCache({
          typePolicies: {
            ...KeyFieldPolicies,
            Query: {
              fields: {
                ...QueryPolicies,
              },
            },
          },
        }),
        connectToDevTools: process.env.GATSBY_ENV === 'dev',
      }),
    [link],
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
